import { setCookie, getCookie, deleteCookie } from '@/helpers/CookieHelper.js';

// Thin Vue mixin wrapper around the shared CookieHelper so existing components
// keep calling this.setCookie / this.getCookie / this.deleteCookie unchanged.
export const cookieMixin = {
  methods: {
    setCookie,
    getCookie,
    deleteCookie
  }
};
